module.exports = __webpack_public_path__ + "images/3fb84a340a35dfefa90b96b5e406a8cf.svg";